import { EntityService } from 'src/service/EntityService';
import {
  AGREEMENT_SIGNER_ROLE,
  SigningOrderPayload
} from '../../quan-ly-tai-lieu/components/signing-order.types';
import {
  DEFAULT_SIGNING_MODE,
  normalizeSigningParties
} from '../../quan-ly-tai-lieu/components/signing-order.utils';

export class AgreementTemplateService extends EntityService {

  static entity = 'iam-main/template-agreements';

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/detail`).then(res => {
      const data = res.data || {};
      return {
        ...data,
        signingModeEnumId: data.signingModeEnumId || 'AgtSignParallel',
        agreementParties: normalizeSigningParties(data.agreementParties || [])
      };
    });
  }

  static create(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/create`, this.toSigningPayload(data)).then(res => res.data);
  }

  static update(id: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/${id}/update`, this.toSigningPayload(data)).then(res => res.data);
  }

  private static toSigningPayload(data: any): any {
    const signing = data as Partial<SigningOrderPayload>;
    return {
      ...data,
      signingModeEnumId: signing.signingModeEnumId || DEFAULT_SIGNING_MODE,
      agreementParties: normalizeSigningParties(signing.agreementParties || []).map(party => ({
        partyId: party.partyId,
        partyName: party.partyName,
        emailAddress: party.emailAddress,
        recipientInfoStatus: party.recipientInfoStatus,
        sequenceNum: party.sequenceNum
      })),
      signaturePositions: (data.signaturePositions || []).map((position: any) => ({
        ...position,
        roleTypeId: AGREEMENT_SIGNER_ROLE
      })),
      roles: undefined
    };
  }

  static delete(id: string): Promise<any> {
    return this.axios.post(`${this.entity}/${id}/delete`).then(res => res.data);
  }

  static getFormFieldTypes(): Promise<any> {
    return this.axios.get(`iam-common/agreement-form-field-types`).then(res => res.data);
  }

  static extractFields(fileId?: string, contentFile?: File): Promise<any> {
    const formData = new FormData();
    if (fileId) formData.append('fileId', fileId);
    if (contentFile) formData.append('contentFile', contentFile);
    return this.axios.post(`${this.entity}/extract-fields`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  }


  static getFormFields(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/formFields`).then(res => res.data);
  }

  static setFormFields(agreementId: string, dbFormFields: Array<any>): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/formFields`, { dbFormFields }).then(res => res.data);
  }



  static getAgreementList(disabled: string, lazyLoadEvent: string, params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/list?disabled=${disabled}&lazyLoadEvent=${lazyLoadEvent}`, { params }).then(res => res.data);
  }
  static findAgreementList(params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/find`, { params }).then(res => res.data);
  }
  static getOrderItemPrototypeFields(): Promise<any> {
    return this.axios.get(`${this.entity}/prototype-fields`).then(res => res.data);
  }
  static getPDFFile(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/download-pdf`).then(res => res.data);
  }

  // Upload Excel để tạo hàng loạt tài liệu
  static uploadExcel(agreementId: string, formData: FormData): Promise<any> {
    return this.axios.post(`${this.entity}/${agreementId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  }

  // Tải file Excel mẫu
  static downloadTemplate(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/download-template`, { responseType: 'blob' });
  }
}
